module.exports = __webpack_public_path__ + "static/img/kafei.e8f3ccbb.png";